<div class="prospect_top_sec">
    <div class="d-flex" style="justify-content: space-between;">
        <li class="Listcustom"><label>Name</label> <span class="mx-2">:</span> {{TenantName}}</li>
        <li class="Listcustom"><label>Phone</label><span class="mx-2">:</span>{{CountryCode}} {{Phone| phone:1}}</li>
        <li class="Listcustom"><label>Email</label><span class="mx-2">:</span> {{EmailID}}</li>
        <li class="Listcustom" *ngIf="!isQuickInqRes || Existingtenant"><label>Address</label><span class="mx-2">:</span> {{Address}}</li>
        <li class="Listcustom" *ngIf="!isQuickInqRes || Existingtenant"><label>City</label><span class="mx-2">:</span> {{City}}</li>
        <li class="Listcustom"><label>Unit Type/Unit #</label><span class="mx-2">:</span>{{unitTypeCode}} / {{unitDetails.UnitNumber}}</li>
    </div>
    <h5 class="prospectsHeader" i18n="@@Notes">Notes</h5>
</div>

<div class="row mt-3">
    <div class="col mx-0 w-100 mb-2">
        <app-call-script [section]="section" style="width: 100%;"></app-call-script>
    </div>
    <div class="col-md-12">
        <label i18n="@@InternalNote">Internal Note<span class="required" *ngIf="internalNoteField">*</span></label>
        <label class="pure-material-checkbox ms-3">
            <input class="custom-control-input" type="checkbox" class="form-control" [(ngModel)]="prioritynote"
                (change)="changePriority($event)" appHighlightCallScriptFields [fieldName]="'prioritynote'"
                [linkedFieldsList]="callScriptFields">
            <span>Priority Notes<span class="required" *ngIf="priorityNoteField">*</span></span>
        </label>
        <div class="ms-3 d-inline-flex label_responsive">
            <span style="width: 155px;" class="span_margin">Keep Active Until</span>
            <ejs-datepicker [readonly]="!prioritynote" class="form-control p-0 ipad-date date-height h-auto" name="date"
                format='MM/dd/yyyy' floatLabelType='Always' [(ngModel)]="keepActiveDate" [min]='today'
                [allowEdit]="false">
            </ejs-datepicker>
        </div>
        <textarea rows="4" class="form-control mt-2" [(ngModel)]="internalNotes" (ngModelChange)="setNotesDirty($event)"
            #interNote="ngModel" [ngClass]="{'highlight-textarea': prioritynote === true}" [style.color]="textareaColor"
            appHighlightCallScriptFields [fieldName]="'internalNotes'" [linkedFieldsList]="callScriptFields" appRestrictHtmltagchars></textarea>
        <div class="alert alert-danger" *ngIf="internalNoteField && interNote.touched && internalNotes === ''">
            <span>
                Internal Note is required
            </span>
        </div>
    </div>
    <div class="col-md-12 mt-4">
        <label i18n="@@CustomerNote">Customer Note<span class="required" *ngIf="customerNoteField">*</span></label>
        <textarea rows="4" class="form-control" [(ngModel)]="customerNotes" (ngModelChange)="setNotesDirty($event)"
            #customerNote="ngModel" appHighlightCallScriptFields [fieldName]="'customerNotes'"
            [linkedFieldsList]="callScriptFields" appRestrictHtmltagchars></textarea>
        <div class="alert alert-danger" *ngIf="customerNoteField && customerNote.touched && customerNotes === ''">
            <span>
                Customer Note is required
            </span>
        </div>
    </div>

</div>

<div class="row mx-0 mt-4" *ngIf="notesGridData.length !== 0">
    <div class="scroll_outer">
        <div class="scroll_inner_small">
            <ejs-tooltip #tooltip position='BottomCenter' target=".e-rowcell.customcss">
                <ejs-grid #sharedNotesGrid [dataSource]='notesGridData' class="Table_Height_pros table-striped "
                    [gridLines]='lines' height='100' allowFiltering='true' allowSorting='true'
                    [filterSettings]='filterSettings' (dataBound)='dataBound($event)' (mouseover)='mouseover($event)'>
                    <e-columns>

                        <e-column field='NotesDate' i18n-headerText="@@Date" headerText='Created Date' width='50'
                            textAlign='Left'>
                            <ng-template #template let-data>
                                <span class="dataName">{{data.NotesDate | date: 'MM/dd/yyyy hh:mm:ss a'}}</span>
                            </ng-template>
                        </e-column>

                        <e-column field='Creator' i18n-headerText="@@Creator" headerText='Created By' width='50'
                            textAlign='Left'>
                            <ng-template #template let-data>
                                <span class="dataName">{{data.Creator}}</span>
                            </ng-template>
                        </e-column>

                        <e-column field='Type' i18n-headerText="@@Type" headerText='Notes Type' width='50'
                            textAlign='Left'>
                            <ng-template #template let-data>
                                <span class="dataName">{{data.Type}}</span>
                            </ng-template>
                        </e-column>

                        <e-column field='Notes' i18n-headerText="@@Notes" headerText='Notes' width='50' textAlign='Left'
                            [customAttributes]='customAttri'>
                            <ng-template #template let-data>
                                <span class="dataName">{{data.Notes}}</span>
                            </ng-template>
                        </e-column>

                    </e-columns>
                </ejs-grid>
            </ejs-tooltip>
        </div>
    </div>
</div>

<div class="bottom_button mt-3 pb-0">
    <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal" i18n="@@Cancel"
        (click)="onNotesCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="savenotes()" i18n="@@Save"
        [disabled]="disableSave()">Save</button>
</div>